

export default function IntroInstallationComponent(){

    return (
    <section id="intro" className="wrapper special">
      <header className="major">
        <h2>
          Easy install, Easy to use
          {/*<br />*/}
          {/*Because not everything needs to be complicated*/}
        </h2>
      </header>
      <ul className="icons major">
        <li>
            <span className="icon solid fa-laptop zi-mobile2">
              <span className="label">Mobile</span>
              {/*<i className={'zi-mobile2'}></i>*/}
            </span>
        </li>
          <li>
            <span className="icon solid fa-mouse zi-mobile2">
              <span className="label">Mobile</span>
                {/*<i className={'zi-mobile2'}></i>*/}
            </span>
          </li>
          <li>
            <span className="icon solid fa-keyboard zi-mobile2">
              <span className="label">Mobile</span>
                {/*<i className={'zi-mobile2'}></i>*/}
            </span>
          </li>

      </ul>
    </section>
  );
}
